import React, { useEffect, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { connect } from "react-redux";

import * as actions from "../store/actions/index";

import ErrorBoundary from "../hoc/ErrorBoundary.js";
import { ToastProvider } from "../contexts/ToastContext";

import { withRouter } from "../shared/utility";
import DefaultLayout from "../components/layouts/DefaultLayout";
import Login from "../views/authentication/Login";
import ForgotPassword from "../views/authentication/ForgotPassword";
import ResetPassword from "../views/authentication/ResetPassword";
import { getPageTitle } from "../shared/routeTitles";

const PUBLIC_AUTH_PATHS = ["/login", "/forgot-password", "/reset-password"];

function App(props) {
  const { autchCheckCart, authCheckOrderDetails, authCheckState, business } =
    props;

  useEffect(() => {
    authCheckState();
  }, [authCheckState]);

  useEffect(() => {
    autchCheckCart();
  }, [autchCheckCart]);

  useEffect(() => {
    authCheckOrderDetails();
  }, [authCheckOrderDetails]);

  let routes = null;

  const authToken = localStorage.getItem("authToken");

  useEffect(() => {
    if (!authToken) {
      const path = props.router?.location?.pathname ?? "/login";
      if (PUBLIC_AUTH_PATHS.includes(path)) {
        document.title = getPageTitle(path);
      } else {
        document.title = "Login | Flux Orders";
      }
    }
  }, [authToken, props.router?.location?.pathname]);

  let authRedirect = null;
  if (authToken) {
    if (props.isAuthenticated) {
      routes = (
        <Routes>
          <Route path="*" element={<DefaultLayout business={business} />} />
        </Routes>
      );
    }
  } else {
    routes = (
      <Routes>
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Login />} />
      </Routes>
    );
  }

  return (
    <ToastProvider>
      <div className="h-full">
        {authRedirect}
        <ErrorBoundary>
          <Suspense fallback={<p>Loading...</p>}>{routes}</Suspense>
        </ErrorBoundary>
      </div>
    </ToastProvider>
  );
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.authToken !== null,
    business: state.auth.business,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    authCheckState: () => dispatch(actions.authCheckState()),
    autchCheckCart: () => dispatch(actions.autchCheckCart()),
    authCheckOrderDetails: () => dispatch(actions.authCheckOrderDetails()),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
